import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder, Color, Spacing } from '@genial/design-tokens';
import React from 'react';

interface CardHeroErrorProps {
  onRefresh?: () => void;
}

export const CardHeroError: React.FC<CardHeroErrorProps> = ({ onRefresh }) => {
  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy} w="full">
      <HStack
        borderRadius={BoxBorder.heavy}
        backgroundColor={Color.background}
        paddingX={Spacing['inline.xxxs']}
        paddingY={Spacing['inline.xxs']}
        space={[Spacing['inline.nano'], Spacing['inline.xxxs'], Spacing['inline.xxs']]}
        alignItems="center"
        justifyContent="center">
        <Stack>
          <UI.Icon
            testId="warning-icon"
            name="Warning"
            color={Color['feedback.attention.default']}
            size="md"
          />
        </Stack>
        <VStack maxW="5/6" space={Spacing['stack.nano']}>
          <UI.Text maxW="full">
            No momento não conseguimos te mostrar os resultados. Tente novamente em alguns
            instantes.
          </UI.Text>
          <UI.Button
            size="md"
            variant="textLink"
            testID="refresh-button"
            p={0}
            rightIcon={
              <UI.Icon
                name="Refresh"
                size="xxs"
                testId="aa"
                color={Color['brand.tertiary.principal']}
              />
            }
            onPress={onRefresh}>
            Recarregar
          </UI.Button>
        </VStack>
      </HStack>
    </UI.Shadow>
  );
};
